Vendd.Scripts.load(function () {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'finloup-placement', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-finloup-placement', $context);

        if ($control.length < 1)
            return;

        //finloup pop up
        $control.on('click', '.js-finloup-popup', function (e) {
            var externalUrl = "https://finloupms-bucket.s3.eu-central-1.amazonaws.com/externalpopup/";
            var content = LhApp.Context.Language === "el" ? "finloup_popup_el.html" : "finloup_popup.html";
            var parent = "?parent=" + window.document.location;
            var iframeUrl = externalUrl + content + parent;

            $.fancybox.open({
                src: iframeUrl,
                type: "iframe",
                toolbar: false,
                smallBtn: true,
                hash: null,
                baseClass: 'finloup-pop-up'
            });
        });
    });
   
});
